import ModulePage from "./pages/ModulePage";

const moduleRoutes = [
  { path: "/admin/modules", element: <ModulePage /> }
];

export default moduleRoutes;  